import React from 'react';

interface TableCellSkeletonProps {
  width?: string;
  height?: string;
  className?: string;
}

export default function TableCellSkeleton({ width = '65px', height = '20px', className = '' }: TableCellSkeletonProps) {
  return <div className={`table-cell-skeleton ${className}`} style={{ width, height }} />;
}
